import React from "react";
import WhyChooseUsimg from "../../Assets/homeimgs/WhyChooseUsimgs.png";
import { useNavigate } from "react-router-dom";
const WhyChooseUs = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="grid grid-cols-1 lg:grid-cols-2 md:mx-16 mx-6 gap-8 md:mt-10 mt-5">
        <div data-aos="zoom-in-right">
          <img
            src={WhyChooseUsimg}
            alt="Industrial port with cranes and water at dusk"
            className="h-auto"
          />
        </div>
        <div
          className="lg:space-y-5 space-y-3 flex justify-center flex-col tracking-wide"
          data-aos="zoom-in-left"
        >
          <h2 className="text-4xl font-bold mb-4">Why Choose Us !</h2>
          <p className="text-gray-600 text-base md:text-md lg:text-xl">
            The OTL is committed to provide timely quality services for
            maintaining trust and confidence of the client who reposed faith in
            us.
          </p>
          <p className="text-gray-600 text-base md:text-md lg:text-xl">
            As a responsibility to the society, we will endeavor to promote
            green technology, provide humane touch, integrate landscaping and
            tree plantation to the infrastructure planning.
          </p>
          <p className="text-gray-600 text-base md:text-md lg:text-xl">
            We also pledge to nurture the young talents of the organization to
            upgrade their technical skill with deliberations, Seminar, Workshops
            and trainings.
          </p>
          <div>
            <button
              onClick={() => {
                navigate("/about");
                window.scrollTo(600, 0);
              }}
              className="tracking-wide bg-[#1522ED] text-white font-bold py-2 px-4 rounded"
            >
              Know More
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WhyChooseUs;
